/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Project } from '../models/project';

@Injectable({
  providedIn: 'root',
})
export class WorkflowConditionProjectControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation workflowConditionProjectControllerGetProject
   */
  static readonly WorkflowConditionProjectControllerGetProjectPath = '/workflow-conditions/{id}/project';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProject$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<Array<Project>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowConditionProjectControllerService.WorkflowConditionProjectControllerGetProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Project>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProject(params: {
    id: string;
  }): Observable<Array<Project>> {

    return this.getProject$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Project>>) => r.body as Array<Project>)
    );
  }

}
